<template>
  <v-navigation-drawer
    app
    temporary
    hide-overlay
    v-model="localDrawer"
    right
    class="navigation-drawer-right"
  >
    <div
      class="d-flex align-center justify-center pt-12 mt-12"
      v-if="comments_loading"
    >
      <v-progress-circular
        indeterminate
        size="30"
        width="3"
        color="accent"
      ></v-progress-circular>
    </div>
    <div
      v-else-if="
        displayed_comments &&
          displayed_comments !== null &&
          displayed_comments.length > 0
      "
    >
      <!-- comment.senderUserId === selector_id -->
      <div style="height: 65px;"></div>
      <div class="my-2">
        <div
          v-for="(comment, index) in displayed_comments"
          :key="index"
          class="px-4 d-flex"
          :class="
            comment.senderUserId === selector_id
              ? 'justify-end'
              : 'justify-start'
          "
        >
          <div
            style="word-break: break-word;"
            class="my-1 mx-0 pa-2 body-2"
            :class="
              comment.senderUserId === selector_id
                ? 'chatCardNoBorderLeft green lighten-2'
                : 'chatCardNoBorderRight grey lighten-2'
            "
          >
            <v-row class="ma-0 pa-0">
              <v-col class="ma-0 pa-0">
                <v-row class="ma-0 pa-0">
                  <div class="ma-0 pa-0 d-flex align-start">
                    <label class="ma-0 pa-0 body-2 grey--text text--darken-3">
                      {{ comment.senderInfo.email }}
                    </label>
                  </div>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <span class="body-2 light blue--text text--darken-3"
                    ><label
                      >{{ formatDate(comment.createdAt, 'date') }},
                      {{ formatDate(comment.createdAt, 'time') }}</label
                    ></span
                  >
                </v-row>
              </v-col>
              <v-col
                v-if="comment.senderUserId === selector_id"
                class="ma-0 pa-0"
                cols="2"
              >
                <v-btn
                  @click="
                    () => {
                      commentToEdit = comment.text;
                      commentToEditId = comment._id;
                      commentToEditIndex = index;
                      editDialog = true;
                    }
                  "
                  icon
                  ><v-icon size="15">mdi-pencil</v-icon></v-btn
                >
              </v-col>
            </v-row>

            <v-row class="ma-0 pa-0">
              <v-col class="ma-0 pa-0" cols="12">
                <div class="ma-0 pa-0">
                  <p class="ma-0 pa-0 subtitle-1 black--text text--darken-3">
                    {{ comment.text }}
                  </p>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <div style="height: 105px;"></div>
      <div id="scrollableDiv"></div>
    </div>
    <div
      v-else
      class="mx-0 mt-12 pt-12 pb-0 mb-0 px-0 d-flex justify-center align-center"
    >
      <label class="mt-12 pt-12 pa-0 grey--text">No comments to show</label>
    </div>
    <v-dialog v-model="editDialog" persistent width="350">
      <v-card tile class="ma-0 pa-6" style="overflow: hidden">
        <div class="d-flex flex-row align-start ma-0 pa-0">
          <v-textarea
            class="ma-0 pa-0"
            label="Edit Your Comment"
            type="text"
            dense
            flat
            outlined
            v-model="commentToEdit"
            @blur="$v.commentToEdit.$touch"
            :error-messages="requiredError($v.commentToEdit)"
          ></v-textarea>
        </div>
        <div class="d-flex justify-center align-center">
          <v-btn
            :loading="btn_loading_edit"
            depressed
            class="mx-2 green white--text"
            :disabled="sendDisabled"
            @click="
              () => {
                let commentObj = {};
                commentObj.commentIndex = commentToEditIndex;
                commentObj.commentId = commentToEditId;
                commentObj.comment = commentToEdit;
                editComment(commentObj);
              }
            "
            >Send</v-btn
          >
          <v-btn
            depressed
            class="mx-2 red white--text"
            @click="closeEditDialog()"
            >Discard</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <v-footer class="white ma-0 pa-2" absolute>
      <div class="px-1 py-0 my-0 d-flex flex-row align-end">
        <v-textarea
          outlined
          :auto-grow="true"
          :rows="1"
          no-resize
          placeholder="Write your Comment here..."
          v-model="comment"
        ></v-textarea>
        <v-btn
          @click="
            () => {
              if (comment.trim() !== '') {
                postComment(comment.trim());
              }
            }
          "
          icon
          :loading="btn_loading"
          class="ml-2 mb-6 pa-0 align-self-end"
          ><v-icon color="red">mdi-send</v-icon></v-btn
        >
      </div>
    </v-footer>
  </v-navigation-drawer>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';

export default {
  name: 'Comments',
  data() {
    return {
      comment: '',
      editDialog: false,
      commentToEdit: '',
      commentToEditId: '',
      commentToEditIndex: '',
      sendDisabled: true,
      localDrawer: false,
    };
  },
  props: {
    displayed_comments: {
      type: Array,
      required: true,
    },
    value: {
      type: Boolean,
    },
    reset: {
      type: Boolean,
      required: true,
    },
    selector_id: {
      type: String,
      required: true,
    },
    comments_loading: {
      type: Boolean,
      required: false,
    },
    btn_loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    btn_loading_edit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    setComments() {
      this.$emit('setComments');
    },
    postComment() {
      this.$emit('postComment', this.comment);
    },
    editComment(commentObj) {
      this.$emit('editComment', commentObj);
    },
    closeEditDialog() {
      this.editDialog = false;
      this.commentToEdit = '';
      this.commentToEditId = '';
      this.commentToEditIndex = '';
    },
    requiredError(field) {
      const errors = [];
      if (!field.$dirty) {
        return errors;
      }
      !field.required && errors.push('Comment cannot be blank');
      return errors;
    },
    scrollToBottom() {
      var div = document.getElementById('scrollableDiv');
      // console.log(document.getElementById('scrollableDiv'));
      // console.log(div.scrollTop,  div.scrollHeight, div.clientHeight);
      // div.scrollTop = div.scrollHeight;
      // div.scrollTop = div.scrollHeight - div.clientHeight;
      if (div) {
        div.scrollIntoView(false);
      }
    },
    // areEqualMinutes(time1, time2) {
    //   if (moment(time1).isSame(time2, 'day')) {
    //     return moment(time1).isSame(time2, 'm');
    //   } else {
    //     return false;
    //   }
    // },
    formatDate(dateTime, type) {
      var today = moment().startOf('day');
      var yesterday = moment()
        .subtract(1, 'days')
        .startOf('day');

      var weekAgo = moment()
        .subtract(7, 'days')
        .startOf('day');

      var yearAgo = moment()
        .subtract(365, 'days')
        .startOf('day');

      switch (type) {
        case 'time':
          return moment(dateTime).format('hh:mm A');
          break;
        case 'date':
          var sentDay = moment(dateTime);
          if (sentDay.isAfter(weekAgo, 'd')) {
            if (sentDay.isSame(today, 'd')) {
              return 'Today';
            } else if (sentDay.isSame(yesterday, 'd')) {
              return 'Yesterday';
            } else {
              return sentDay.format('dddd');
            }
          } else if (sentDay.isAfter(yearAgo)) {
            return sentDay.format('MMMM D');
          } else {
            return sentDay.format('D/M/YY');
          }
          break;
      }
    },
  },
  validations: {
    commentToEdit: {
      required,
    },
  },

  mounted() {
    // console.log(this.selector_id);
  },
  watch: {
    btn_loading_edit: {
      handler(value) {
        // console.log('Here', value);
        if (!value) {
          this.closeEditDialog();
        }
      },
    },
    btn_loading: {
      handler(value) {
        if (!value) {
          this.comment = '';
          setTimeout(() => {
            this.scrollToBottom();
          }, 1);
        }
      },
    },
    commentToEdit: {
      handler(value) {
        if (this.$v.$invalid) {
          this.sendDisabled = true;
        } else {
          this.sendDisabled = false;
        }
      },
    },
    reset: {
      handler() {
        this.setComments();
        // console.log(this.displayed_comments);
      },
    },
    comments_loading: {
      handler() {
        setTimeout(() => {
          this.scrollToBottom();
        }, 1);
      },
    },
    value: {
      handler() {
        this.localDrawer = this.value;
        setTimeout(() => {
          this.scrollToBottom();
        }, 1);
      },
    },
    localDrawer: {
      handler() {
        this.$emit('input', this.localDrawer);
        setTimeout(() => {
          this.scrollToBottom();
        }, 1);
      },
    },
  },
};
</script>

<style scoped>
.navigation-drawer-right {
  /* margin-top: 65px; */
  min-width: 18rem;
  z-index: 2;
}
.chatCardNoBorderLeft {
  border-radius: 10px 10px 0px 10px;
}
.chatCardNoBorderRight {
  border-radius: 10px 10px 10px 0px;
}
/* .footer {
  height: rem;
} */
</style>